var map = {
	"./1.svg": 2664,
	"./10.svg": 341,
	"./11.svg": 6547,
	"./12.svg": 3984,
	"./13.svg": 3063,
	"./14.svg": 2304,
	"./15.svg": 6925,
	"./16.svg": 3669,
	"./17.svg": 1791,
	"./18.svg": 1139,
	"./19.svg": 5531,
	"./2.svg": 3487,
	"./20.svg": 3797,
	"./21.svg": 146,
	"./22.svg": 8555,
	"./3.svg": 7735,
	"./4.svg": 3355,
	"./5.svg": 1524,
	"./6.svg": 8301,
	"./7.svg": 5396,
	"./8.svg": 385,
	"./9.svg": 3129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9801;